import { render, staticRenderFns } from "./FormCoordonateStickersComponent.vue?vue&type=template&id=1d55fbd4&"
import script from "./FormCoordonateStickersComponent.vue?vue&type=script&lang=js&"
export * from "./FormCoordonateStickersComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormCoordonateStickersComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports